import { getContext } from '@adornis/baseql/server/context.js';

/**
 * The logged-in user's id within a BaseQL resolver call stack, or undefined for
 * server/unauthenticated contexts. Uses the AsyncLocalStorage-backed context that
 * the server populates with `userID` (see server/startup.ts ContextManager.upgrade).
 */
export function getCurrentUserID(): string | undefined {
  const ctx = getContext();
  if (!ctx || ctx.serverContext) return undefined;
  return (ctx as { userID?: string }).userID ?? undefined;
}
